import React, { useCallback, useState } from "react";
import ListHeader from "../../common/list/ListHeader";
import ListActions from "../../common/list/ListActions";
import NavigationPagination from "../../common/NavigationPagination";
import { useGetTemplateImagesQuery } from "../../../services/api/repositories/TemplateMailsRepository";
import TableMedia from "./TableMedia";
import { useNavigate } from "react-router-dom";

export default function MediaSection() {
    const navigate = useNavigate();

    const [currentPage, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const {data, isLoading, isFetching} = useGetTemplateImagesQuery(
        {page: currentPage, per_page: perPage},
        {refetchOnMountOrArgChange: true}
    );

    const handleAction = useCallback(() => {
        navigate("/media/new");
    }, [navigate]);

    return (
        <>
            <ListHeader 
                actions={                    
                    <ListActions
                        classAction='btn-add'
                        title="Ajouter un média"
                        textButton="Ajouter un média"
                        handleAction={handleAction}
                    />
                }
                handleSubmit={() => console.log('Submit')}
                handleReset={() => console.log('Reset')}
            >
            </ListHeader>

            {(isLoading || isFetching) && <p>Chargement...</p>}
        
            {((!isLoading && !isFetching) && data !== undefined) && (
                <>
                    {("message" in data) && <p>{data.message}</p>}
                    {("total" in data) && 
                    (<>
                        <TableMedia data={data} />
                        <NavigationPagination currentPage={currentPage} lastPage={data.last_page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />              
                    </>)}
                </>
                )
            }
            
            {((!isLoading && !isFetching) && data === undefined) && 
                <p>Une erreur a été rencontrée.</p>
            }
        </>
    );
}